/**
 * Стовпці, що зараз видно в сітці типу запису (без збереженого подання — ті, що вмістилися за шириною, у порядку показу): «Редагувати подання»
 * без вибраного подання починає з них, як прототип v4 (tvEditCurrent: cols — показані стовпці, сховані — невибрані). Без стану в Redux —
 * це лише підказка для чернетки, що живе, поки відкрита сторінка.
 */
const shown = new Map<string, readonly string[]>();

export const shownColumns = {
  set: (recordType: string, keys: readonly string[]): void => { shown.set(recordType, keys); },
  get: (recordType: string): readonly string[] | undefined => shown.get(recordType),
};
